import { render, staticRenderFns } from "./MailingManagement.vue?vue&type=template&id=297db273&"
import script from "./MailingManagement.vue?vue&type=script&lang=js&"
export * from "./MailingManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports